/*
 *获取报价页
 */
import { DatePicker, Input, message, Select } from 'antd';
import 'assets/style/itemStyle/charterQuote.scss';
import AddUserInfo from 'components/emptyLeg/AddUserInfo';
import InquireDialog from 'components/emptyLeg/InquireDialog';
import HeaderMeta from 'components/headerMeta/HeaderMeta';
import Footer from 'components/layout/Footer';
import SearchAirportCharter from 'components/public/SearchAirportCharter';
import moment from 'moment';
import React, { Component, Fragment } from 'react';
import store from 'redux/store';
import { getCharterQuote, userNeeds } from 'services';
import {
  clearSessionStorage,
  divisionNumber,
  expireDate,
  formatDateHandle,
  formatUtcDate,
  getLocalStorage,
  getSessionStorage,
  setSessionStorage,
  switchTime,
  timeZone,
} from 'untils/auth';
import country from 'untils/country.json';
import { timeList } from 'untils/inquireTimeList';
import { tapLead } from 'untils/tracking';
import Description from './components/Description';
import FeaturedFlights from './components/FeaturedFlights';

const { Option } = Select;
export default class CharterQuote extends Component {
  constructor(props) {
    super(props);
    this.resultRef = React.createRef();
    this.titleRef = React.createRef();
    this.headerRef = React.createRef();
    this.pickerRef = React.createRef();
    this.picker2Ref = React.createRef();
    this.unsubscribe = store.subscribe(() => {
      let inquireSubmit = store.getState().getCharterQuoteChange;
      if (inquireSubmit) {
        this.submitInquireHandle();
        store.dispatch({
          type: 'charterQuoteClear',
        });
      }
    });
  }
  state = {
    bestPrice: {}, // 最佳航班
    resultsList: [], // 航班列表
    tripList: ['One Way', 'Round Trip'], // 单双程
    tripIndex: 0, // 单双程索引值
    showFiltrate: false, // 显示隐藏筛选框
    minPrice: 0, // 最低价格
    maxPrice: 0, // 最高价格
    fromValue: '', //去程机场
    toValue: '', //去程机场
    getLoading: false, // loading
    fromLocation: {
      // 出发地经纬度
      lat: 40,
      lng: -97,
    },
    toLocation: {
      // 目的地经纬度
      lat: 0,
      lng: 0,
    },
    fromName: 'default',
    toName: 'default',
    isShow: false, //表单弹窗是否打开
    openDataList: [], // 下拉框数据
    currentDate: '', // 默认日期
    currentDateOnce: '', // 默认日期
    time: null, // 单程时间
    timeOnce: null, // 双程时间
    passengerNumber: 1, //乘客数量
    user: {}, //用户信息
    timeName: '',
    timeOnceName: '',
    passengerActive: false,
    checkedChoose: true, // 勾选框
    currentFocusInput: '',
    inputRules: {
      // 输入框校验
      fromCity: false, // 出发地
      toCity: false, // 目的地
      fromDate: false, // 去程日期
      toDate: false, // 返程日期
    },
    countrySelectShow: false, // 选择国家区号下拉框
    countryCodeList: country, // 国家区号
    totalPrice: 0,
    dialogType: '', //弹窗类型
    dialogContent: '',
    inquireId: '', // 询价单id
    sourceMenuShow: false, //用户信息来源显示
    addUserInfoShow: false, // 未登录时补全信息弹窗
    dateShow: false, //单程日期显示
    dateTwoShow: false, // 往返日期显示
    searchSuccess: false, // 是否搜索
    dateMonth: new Date(), // 出发日期禁用月份
    dateMonthOnce: new Date(), // 到达日期禁用月份
    scheduleList: [], // 定期航班列表
    emptyLegList: [], // 空腿列表
    scheduleShow: false,
    emptyLegShow: false,
    roundtrip: 0,
    lastSelectedDate: null,
    lastSelectedDateOnce: null,
  };

  scrollToResults = () => {
    const headerEl = this.headerRef && this.headerRef.current;
    if (!headerEl) return;
    const rect = headerEl.getBoundingClientRect ? headerEl.getBoundingClientRect() : null;
    const headerHeight = rect ? rect.height : 0;
    const delta = Math.max(headerHeight - 80, 0);
    if (delta > 0) {
      window.scrollBy({ top: delta, behavior: 'smooth' });
    }
  };

  // 自动聚焦 子传父
  getFocus = (value) => {
    let { toValue } = this.state;
    if (value === 'to') {
      this.pickerRef.current.focus();
    } else {
      if (Object.keys(toValue).length > 0) {
        this.pickerRef.current.focus();
      }
    }
    this.setState({
      currentDate: '',
      lastSelectedDate: null,
      time: null,
      currentDateOnce: '',
      lastSelectedDateOnce: null,
      timeOnce: null,
    });
  };
  // 互换出发目的地
  reverse = () => {
    let { fromValue, toValue } = this.state;
    setSessionStorage('from', JSON.stringify(toValue));
    setSessionStorage('to', JSON.stringify(fromValue));
    clearSessionStorage('userFormData');
    this.setState({
      fromValue: toValue,
      toValue: fromValue,
      currentDate: '',
      currentDateOnce: '',
      lastSelectedDate: null,
      lastSelectedDateOnce: null,
      time: null,
      timeOnce: null,
    });
    this.pickerRef.current.focus();
    if (this.ChildPage1) {
      this.ChildPage1.getCacheData(); //调用出发子组件的dream方法
      this.ChildPage2.getCacheData(); //调用到达子组件的dream方法
    }
  };

  //弹窗信息必填校验
  checkValue = () => {
    message.destroy();
    let {
      tripIndex,
      fromValue,
      toValue,
      currentDate,
      currentDateOnce,
      time,
      timeOnce,
      inputRules,
    } = this.state;
    let notValueLength = 0;

    if (!Object.keys(fromValue).length) {
      notValueLength++;
    } else {
      inputRules.fromCity = false;
    }

    if (!Object.keys(toValue).length) {
      notValueLength++;
    } else {
      inputRules.toCity = false;
    }

    if (!currentDate || !time) {
      notValueLength++;
    } else if (currentDate && time) {
      inputRules.fromDate = false;
    }

    if (tripIndex === 1 && (!currentDateOnce || !timeOnce)) {
      notValueLength++;
    } else if (tripIndex === 1 && currentDate && time) {
      inputRules.toDate = false;
    }

    this.setState({
      inputRules,
    });

    // 都未填只提示弹窗信息
    if ((tripIndex === 0 && notValueLength === 3) || (tripIndex === 1 && notValueLength === 4)) {
      return message.warning('Please enter your information!');
    }

    // 未填写>1, 提示弹窗信息并且置亮input
    if (
      (tripIndex === 0 && notValueLength > 1 && notValueLength <= 3) ||
      (tripIndex === 1 && notValueLength > 1 && notValueLength <= 4)
    ) {
      if (!Object.keys(fromValue).length) inputRules.fromCity = true;
      if (!Object.keys(toValue).length) inputRules.toCity = true;
      if (!currentDate || !time) inputRules.fromDate = true;
      if (tripIndex === 1 && (!currentDateOnce || !timeOnce)) inputRules.toDate = true;

      this.setState({
        inputRules,
      });
      return message.warning('Please enter your information!');
    }

    // 仅一项未填提示弹窗信息并且置亮input
    let msg = '';
    if ((tripIndex === 0 || tripIndex === 1) && notValueLength === 1) {
      if (!Object.keys(fromValue).length) {
        inputRules.fromCity = true;
        msg = 'Please enter the place of departure';
      }
      if (!Object.keys(toValue).length) {
        inputRules.toCity = true;
        msg = 'Please enter the destination place';
      }

      if (!currentDate || !time) {
        inputRules.fromDate = true;
      }
      if (tripIndex === 1 && (!currentDateOnce || !timeOnce)) {
        inputRules.toDate = true;
      }

      if (
        !currentDate ||
        (!currentDate && !time) ||
        (tripIndex === 1 && (!currentDateOnce || (!currentDateOnce && !timeOnce)))
      ) {
        msg = 'Please enter the date';
      } else if (!time || (tripIndex === 1 && !timeOnce)) {
        msg = 'Please enter the time';
      }

      this.setState({
        inputRules,
      });

      return message.warning(msg);
    }

    // 都已填，出发地/目的地相同
    if ((tripIndex === 0 || tripIndex === 1) && notValueLength === 0) {
      if (fromValue.id && toValue.id && fromValue.id === toValue.id) {
        return message.warning('The departure city and destination city cannot be the same!');
      }
    }
  };

  // 点击Get PriceModule Quote按钮
  searchCharquote = () => {
    let {
      tripIndex,
      passengerNumber,
      fromValue,
      toValue,
      currentDate,
      currentDateOnce,
      time,
      timeOnce,
    } = this.state;

    //校验
    this.checkValue();

    if (
      (tripIndex === 0 &&
        passengerNumber &&
        Object.keys(fromValue).length &&
        Object.keys(toValue).length &&
        currentDate &&
        time) ||
      (tripIndex === 1 &&
        passengerNumber &&
        Object.keys(fromValue).length &&
        Object.keys(toValue).length &&
        currentDate &&
        time &&
        currentDateOnce &&
        timeOnce)
    ) {
      this.setState({
        getLoading: true,
      });
      this.getResultsList();
    }
  };

  // 搜索结果列表
  getResultsList = async () => {
    let {
      tripIndex,
      toValue,
      fromValue,
      passengerNumber,
      currentDate,
      timeName,
      currentDateOnce,
      timeOnceName,
    } = this.state;
    let userFormData = JSON.parse(getSessionStorage('userFormData') || '{}');

    if (!Object.keys(fromValue).length || !Object.keys(toValue).length) {
      return false;
    }
    let goTime = moment(currentDate).format('YYYY-MM-DD') + ' ' + timeName;
    let backTime = moment(currentDateOnce).format('YYYY-MM-DD') + ' ' + timeOnceName;
    let timezone = fromValue.timezone;
    const params = {
      startAiportId: fromValue.id || fromValue.airportId,
      endAirportId: toValue.id || toValue.airportId,
      seat: passengerNumber,
      startIdType: fromValue.idType || 'city',
      endIdType: toValue.idType || 'city',
      departureTime: formatUtcDate(goTime, timezone),
    };
    if (tripIndex)
      (params.returnTime = formatUtcDate(backTime, timezone)),
        this.setState({
          resultsList: [],
        });

    this.createCharterUrlParams({
      startIdType: params.startIdType,
      endIdType: params.endIdType,
      startId: params.startAiportId,
      endId: params.endAirportId,
      startKey: fromValue.name,
      endKey: toValue.name,
      tripType: tripIndex.toString(),
    });

    // 获取包机列表
    getCharterQuote(params).then((res) => {
      if (res.code) {
        if (res.data.scheduleFlight && Object.keys(res.data.scheduleFlight).length > 0) {
          let scheduleList = res.data.scheduleFlight;
          this.setState({
            scheduleList,
            scheduleShow: true,
          });
        } else {
          this.setState({
            scheduleList: [],
            scheduleShow: false,
          });
        }
        if (res.data.emptyLeg && Object.keys(res.data.emptyLeg).length > 0) {
          let emptyLegList = res.data.emptyLeg;
          this.setState({
            emptyLegList,
            emptyLegShow: true,
          });
        } else {
          this.setState({
            emptyLegList: [],
            emptyLegShow: false,
          });
        }

        if (res.data.charterQuote?.length > 0) {
          let resultsList = res.data.charterQuote;

          const nameMap = new Map([
            ['Entry Level Jet', 0],
            ['Light Jet', 1],
            ['Super Light Jet', 2],
            ['Midsize Jet', 3],
            ['Super Midsize Jet', 4],
            ['Heavy Jet', 5],
            ['Ultra Long Range Jet', 6],
            ['VIP Airliner', 7],
            ['Helicopter', 8],
            ['Piston', 9],
            ['Turbo Prop', 10],
          ]);
          const sortResultList = resultsList
            .map((item) => {
              //处理价钱展示
              let price = item.Price?.split('-');

              return {
                ...item,
                Picture: item.Picture ? JSON.parse(item.Picture) : [],
                minPrice: price[0] ? Math.ceil(price[0]) : undefined,
                maxPrice: price[0] ? Math.ceil(price[1]) : undefined,
              };
            })
            .sort((a, b) => {
              return nameMap.get(a.Category) - nameMap.get(b.Category);
            });

          this.setState(
            {
              getLoading: false,
              resultsList: sortResultList,
            },
            () => {
              this.scrollToResults();
            }
          );
        } else {
          this.setState({
            getLoading: false,
          });
          return message.warning('There are no relevant charter flights.');
        }
        this.setState({
          searchSuccess: true,
          roundtrip: tripIndex,
        });
        userFormData['dateStart'] = moment(currentDate).format('YYYY-MM-DD');
        userFormData['timeStart'] = timeName;
        if (currentDateOnce) userFormData['dateEnd'] = moment(currentDateOnce).format('YYYY-MM-DD');
        if (timeOnceName) userFormData['timeEnd'] = timeOnceName;
        setSessionStorage('userFormData', JSON.stringify(userFormData));
      }
    });
  };

  // 创建包机专属链接
  createCharterUrlParams = (infos) => {
    const { location, history } = this.props;
    const urlParams = new URLSearchParams();
    urlParams.set('startIdType', infos.startIdType);
    urlParams.set('endIdType', infos.endIdType);
    urlParams.set('startId', infos.startId);
    urlParams.set('endId', infos.endId);
    urlParams.set('startKey', infos.startKey);
    urlParams.set('endKey', infos.endKey);
    urlParams.set('tripType', infos.tripType);
    history.push(`${location.pathname}?${urlParams.toString()}`);
  };

  //清空包机列表数据（子传父）
  clearFlightsList = (data) => {
    this.setState({
      resultsList: data,
    });
  };

  // 显示弹窗操作
  showDialogHandle = () => {
    let user = getLocalStorage('user') ? JSON.parse(getLocalStorage('user')) : {};
    this.setState({
      addUserInfoShow: false,
      dialogType: getLocalStorage('token') && !user.phone ? 'phoneModle' : 'repeatModle',
    });
  };

  //获取报价弹窗
  submitInquireHandle = (data) => {
    let {
      tripIndex,
      fromValue,
      toValue,
      passengerNumber,
      currentDate,
      currentDateOnce,
      time,
      newTime,
    } = this.state;
    let timezone = fromValue.timezone;
    let nowDate = formatDateHandle(new Date(), timezone);
    const isExpired = expireDate(
      moment(moment(currentDate).format('MM/DD/YYYY') + ' ' + time, 'MM/DD/YYYY h:mm A').format(),
      nowDate
    );
    if (!isExpired)
      return message.error('The page stay is too long, please re-select the departure time.');
    let params = getSessionStorage('chaData') ? JSON.parse(getSessionStorage('chaData')) : {};
    let minPrice = data?.minPrice || getSessionStorage('minPrice');
    let maxPrice = data?.maxPrice || getSessionStorage('maxPrice');
    const category = data?.Category || params?.category;
    const aircraftId = data?.AircraftID || params?.aircraftId;
    const passengersSection = data?.Seat || params?.passengersSection;
    const price = minPrice + '-' + maxPrice;

    let backTime = 'default';
    if (tripIndex === 1) {
      let timeOnce = getSessionStorage('userFormData')
        ? JSON.parse(getSessionStorage('userFormData')).timeEnd
        : {};
      backTime = moment(new Date(currentDateOnce)).format('YYYY-MM-DD') + ' ' + timeOnce;
      backTime = formatUtcDate(backTime, timezone);

      minPrice = minPrice * 2;
      maxPrice = maxPrice * 2;
    }

    params = {
      startAirportId: fromValue?.id,
      endAirportId: toValue?.id,
      startIdType: fromValue.idType || 'airport',
      endIdType: toValue.idType || 'airport',
      passengers: passengerNumber,
      category,
      aircraftId,
      passengersSection,
      price: `$${divisionNumber(minPrice)} - $${divisionNumber(maxPrice)}`,
      rcvEmailFlag: 2,
      timeZone: timeZone(),
      backTime,
      phone: '1',
    };
    let startTime = JSON.parse(getSessionStorage('userFormData'))?.timeStart || newTime;
    let goTime = moment(new Date(currentDate)).format('YYYY-MM-DD') + ' ' + startTime;
    //  修改timezone
    params.goTime = formatUtcDate(goTime, timezone);

    setSessionStorage('chaData', JSON.stringify(params));
    setSessionStorage('minPrice', minPrice);
    setSessionStorage('maxPrice', maxPrice);

    if (getLocalStorage('token')) {
      let user = getLocalStorage('user') ? JSON.parse(getLocalStorage('user')) : {};
      let userId = getLocalStorage('userId');
      params['userId'] = userId;
      params['name'] = user.name;
      params['email'] = user.account;
      if (user.phone) params['phone'] = user.phone;
      if (!user.phone) {
        this.setState({
          addUserInfoShow: false,
          dialogType: 'phoneModle',
          currentParams: params,
        });
      } else {
        this.submitInquireAjax(params);
      }
    } else {
      this.setState({
        addUserInfoShow: true,
        currentParams: params,
      });
    }

    //twitter
    if (window.twttr)
      window.twttr.conversion.trackPid('o8q0k', { tw_sale_amount: price, tw_order_quantity: 1 });
  };

  //提交inquire
  submitInquireAjax = (params) => {
    userNeeds(params).then((res) => {
      if (res.code || (!res.code && res.msg.indexOf('repeat order') > -1)) {
        clearSessionStorage('chaData');
        clearSessionStorage('minPrice');
        clearSessionStorage('maxPrice');

        this.setState({
          routerId: res.data.RouterID || '',
        });
        // 首次提交和重复提交
        if (res.msg.indexOf('repeat order') > -1) {
          this.setState({
            dialogContent:
              'Your inquiry has been successfully submitted. please do not submit it again! Please view more details in My Inquiries. Our Account Manager will get in touch with you as soon as possible.',
            sourceMenuShow: false,
          });
        } else {
          this.setState({
            dialogContent: params.userId
              ? 'Your inquiry has been successfully submitted. Please view more details in My Inquiries. Our Account Manager will get in touch with you as soon as possible.'
              : 'Your inquiry has been successfully submitted. Our Account Manager will get in touch with you as soon as possible.',
            inquireId: res.data.InquireID,
            sourceMenuShow: true,
          });
          tapLead({ userId: params.userId, InquireID: res.data.InquireID });
        }

        this.showDialogHandle();
      } else {
        return message.error('submission failed!');
      }
    });
  };

  //关闭弹窗
  closeDialogHandle = () => {
    this.setState({
      dialogType: '',
      addUserInfoShow: false,
    });
  };

  // 获取机场地址（子传父）
  getAddress = (type, data) => {
    if (type === 'from') {
      this.setState({
        fromValue: data,
      });
    } else {
      this.setState({
        toValue: data,
      });
    }
  };
  // 地图选中地址
  addressValue = (name, value) => {
    let { fromValue, toValue, fromName, toName } = this.state;
    if (name === 'from') {
      fromValue = value;
      fromName = JSON.parse(value.additional).airportIcao;
    } else {
      toValue = value;
      toName = JSON.parse(value.additional).airportIcao;
    }

    if (this.ChildPage1) {
      this.ChildPage1.getCacheData(); //调用出发子组件的dream方法
      this.ChildPage2.getCacheData(); //调用到达子组件的dream方法
    }
    this.setState(
      {
        fromValue,
        toValue,
        fromName,
        toName,
      },
      () => {
        this.getResultsList();
      }
    );
  };
  // 切换单双程
  switchType = (index) => {
    this.setState({
      tripIndex: index,
      resultsList: [],
    });
    let userFormData = !getSessionStorage('userFormData')
      ? {}
      : JSON.parse(getSessionStorage('userFormData'));
    userFormData['type'] = index;
    setSessionStorage('userFormData', JSON.stringify(userFormData));
  };

  // 自动填充时间
  setTime = (date, type) => {
    let { time, timeName, currentDate, fromValue } = this.state;
    let today,
      todayTime,
      timezoneShow = '';
    if (Object.keys(fromValue).length > 0) {
      timezoneShow = fromValue.timezone;
    }
    if (timezoneShow) {
      today = moment.utc().tz(timezoneShow).format('MM/DD/YYYY');
      todayTime = moment.utc().tz(timezoneShow).format('MM/DD/YYYY HH:mm:ss');
    } else {
      today = moment(new Date()).format('MM/DD/YYYY');
      todayTime = new Date();
    }

    let selectDate = moment(date).format('MM/DD/YYYY');
    if (selectDate === today) {
      if (type === 'one') {
        let list = this.filterTime(todayTime, selectDate, timeList);
        if (list.length > 0) {
          this.setState({
            time: list[0].label,
            timeName: list[0].value,
          });
        } else {
          this.setState({
            time: '12:00 PM',
            timeName: '12:00',
          });
        }
      } else {
        let twolist = this.filterTime(new Date(`${selectDate} ${time}`), selectDate, timeList);
        if (twolist.length > 0) {
          this.setState({
            timeOnce: twolist[0].label,
            timeOnceName: twolist[0].value,
          });
        } else {
          this.setState({
            timeOnce: time,
            timeOnceName: timeName,
          });
        }
      }
    } else {
      if (type === 'one') {
        this.setState({
          time: '9:00 AM',
          timeName: '09:00',
        });
      } else {
        currentDate = moment(currentDate).format('MM/DD/YYYY');
        if (selectDate === currentDate) {
          this.setState({
            timeOnce: '10:30 AM',
            timeOnceName: '10:30',
          });
        } else {
          this.setState({
            timeOnce: '9:00 AM',
            timeOnceName: '09:00',
          });
        }
      }
    }
  };

  // 获取日期
  changeDate = (e, type) => {
    let { currentDateOnce } = this.state;
    let userFormData = !getSessionStorage('userFormData')
      ? {}
      : JSON.parse(getSessionStorage('userFormData'));

    if (type === 'one') {
      this.setState({
        currentDate: moment(e, 'YYYY-MM-DD'),
        lastSelectedDate: moment(e, 'YYYY-MM-DD'),
        // time: null, // 单程时间
      });
      this.pickerRef.current.blur();

      if (!currentDateOnce) {
        this.picker2Ref.current?.focus();
      }
      let start = new Date(e).getTime();
      let end = new Date(moment(currentDateOnce).format('MM/DD/YYYY')).getTime();

      if (start > end) {
        this.setState({
          currentDateOnce: '',
          timeOnce: null, // 双程时间
        });

        userFormData['dateEnd'] = '';
      }
      this.setTime(e, 'one');
    } else {
      this.setState({
        currentDateOnce: moment(e, 'YYYY-MM-DD'),
        lastSelectedDateOnce: moment(e, 'YYYY-MM-DD'),
      });
      this.picker2Ref.current?.blur();
      this.setTime(e, 'two');
    }

    // 过滤当天去程时间
    let timeSelectData = this.filterTime(new Date(), e, timeList);
    let list = timeSelectData.length ? timeSelectData : timeList;
    //改变日期时间placeholder
    this.setState({
      defaultEndDate: e,
      defaultStartTime: list.length ? list[0].label : 'Time',
      defaultEndTime: list.length ? list[0].label : 'Time',
    });
  };
  // 打开时间下拉列表
  openSelectTime = (openType, type) => {
    let { time, currentDate, currentDateOnce, fromValue } = this.state;
    let nowTime = fromValue.timezone
      ? new Date(moment.utc().tz(fromValue.timezone).format('YYYY-MM-DD HH:mm'))
      : new Date();
    let nowDate = moment(new Date()).format('MM/DD/YYYY');
    currentDate = moment(currentDate).format('MM/DD/YYYY');
    currentDateOnce = moment(currentDateOnce).format('MM/DD/YYYY');
    let list = [];
    if (type === 'one') {
      // 过滤当天去程时间
      if (currentDate === 'Invalid date') {
        list = this.filterTime(nowTime, nowDate, timeList);
      }
      if (nowDate === currentDate) {
        list = this.filterTime(nowTime, currentDate, timeList);
      }
      this.setState({
        openDataList: list.length ? list : timeList,
        openSelect: openType ? true : false,
      });
    } else {
      // 过滤当天返程时间
      if (nowDate === currentDateOnce) {
        list = this.filterTime(nowTime, currentDateOnce, timeList);
      }
      // 同一天返程时间早于去程时间
      if (currentDate === currentDateOnce) {
        list = this.filterTime(
          new Date(`${currentDate} ${time}`),
          currentDateOnce,
          list.length ? list : timeList
        );
      } else {
        list = timeList;
      }
      this.setState({
        openDataList: list,
        openSelectTwo: openType ? true : false,
      });
    }
  };
  // 获取时间
  handleChange = (value, type) => {
    if (type === 'one') {
      this.picker2Ref.current?.focus();
      this.setState({
        dateTwoShow: true,
      });
    }
    let { currentDate, currentDateOnce, timeOnce, inputRules } = this.state;
    let time = null;
    let timeName = '';

    for (const item of timeList) {
      if (item.value === value) {
        time = item.value;
      }
      if (item.value === value) {
        timeName = item.value;
      }
    }

    currentDate = moment(currentDate).format('MM/DD/YYYY');
    currentDateOnce = moment(currentDateOnce).format('MM/DD/YYYY');
    if (type === 'one') {
      // 同一天返程时间早于去程时间
      if (currentDate === currentDateOnce) {
        if (timeOnce !== null) {
          let timeStart = new Date(`${currentDate} ${value}`);
          let timeEnd = new Date(`${currentDateOnce} ${timeOnce}`);
          if (timeStart.getTime() > timeEnd.getTime()) {
            this.setState({
              timeOnce: null,
            });
          }
        }
      }
      this.setState({
        time,
        timeName,
      });

      if (currentDate && currentDate !== 'Invalid date') {
        inputRules.fromDate = false;
      }
    } else {
      this.setState({
        timeOnce: time,
        timeOnceName: timeName,
      });

      if (currentDateOnce && currentDateOnce !== 'Invalid date') {
        inputRules.toDate = false;
      }
    }

    this.setState({
      openSelect: false,
      openSelectTwo: false,
    });
  };
  //乘客数量限制
  passengerInput = (e) => {
    let { value } = e.target;
    if (value.length > 2) {
      e.target.value = value.slice(0, 2);
    }
    this.setState({
      passengerNumber: e.target.value,
    });
    let userFormData = !getSessionStorage('userFormData')
      ? {}
      : JSON.parse(getSessionStorage('userFormData'));
    userFormData['passenger'] = e.target.value;
    setSessionStorage('userFormData', JSON.stringify(userFormData));
  };
  passengerBlur = (e) => {
    let { value } = e.target;
    if (value < 1 || value === '') {
      this.setState({
        passengerNumber: 1,
      });
    }
    this.setState({
      passengerActive: false,
    });
  };
  passengerFocus = () => {
    this.setState({
      passengerActive: true,
    });
  };

  incrementPassenger = () => {
    const { passengerNumber } = this.state;
    const newValue = Math.min(99, parseInt(passengerNumber) + 1);

    const mockEvent = {
      target: { value: newValue.toString() },
    };
    this.passengerInput(mockEvent);
  };

  decrementPassenger = () => {
    const { passengerNumber } = this.state;
    const newValue = Math.max(1, parseInt(passengerNumber) - 1);

    const mockEvent = {
      target: { value: newValue.toString() },
    };
    this.passengerInput(mockEvent);
  };
  // 显示开始日期
  disabledDateStart = (current) => {
    // Can not select days before today and today
    let { fromValue } = this.state;
    let today,
      timezoneShow = '';
    if (Object.keys(fromValue).length > 0) {
      timezoneShow = fromValue.timezone;
    }
    if (timezoneShow) {
      today = moment.utc().tz(timezoneShow).format('YYYY-MM-DD');
    } else {
      today = moment(new Date()).format('YYYY-MM-DD');
    }
    return moment(current).format('YYYY-MM-DD') < today;
  };
  // 显示结束日期
  disabledDateEnd = (current) => {
    if (!this.state.currentDate) {
      return current && current < moment().startOf('day');
    }
    // Can not select days before today and today
    return current && current < moment(this.state.currentDate);
  };
  // 时间过滤
  filterTime = (nowTime, currentDate, timeList) => {
    return timeList.filter((item) => {
      let time = new Date(`${currentDate} ${item.value}`);
      return time.getTime() > Date.parse(nowTime) + 3600000;
    });
  };
  // 获取缓存数据
  getCacheData = () => {
    let { fromValue, toValue } = this.state;
    //去程机场
    fromValue = !JSON.parse(getSessionStorage('from')) ? {} : JSON.parse(getSessionStorage('from'));
    //返程机场
    toValue = !JSON.parse(getSessionStorage('to')) ? {} : JSON.parse(getSessionStorage('to'));

    let userFormData = !getSessionStorage('userFormData')
      ? {}
      : JSON.parse(getSessionStorage('userFormData'));
    let user = !getLocalStorage('user') ? {} : JSON.parse(getLocalStorage('user'));

    let { timeName, timeOnceName } = this.state;
    let time,
      timeOnce = null;
    if (userFormData.timeStart) {
      for (const item of timeList) {
        if (item.value === userFormData.timeStart) {
          time = item.label;
          timeName = item.value;
        }
      }
    }

    if (userFormData.timeEnd) {
      for (const item of timeList) {
        if (item.value === userFormData.timeEnd) {
          timeOnce = item.label;
          timeOnceName = item.value;
        }
      }
    }

    this.setState({
      fromValue, //去程机场
      toValue, //去程机场
      currentDate: !userFormData.dateStart ? '' : moment(new Date(userFormData.dateStart)), // 默认日期
      currentDateOnce: !userFormData.dateEnd ? '' : moment(new Date(userFormData.dateEnd)), // 默认日期
      tripIndex: userFormData.type ? Number(userFormData.type) : 0,
      time,
      timeOnce,
      timeName,
      timeOnceName,
      passengerNumber: userFormData.passenger || 1,
      user,
    });
  };

  //有无通告栏时样式处理
  mapControlStyle = () => {
    if (
      !getLocalStorage('token') &&
      !getSessionStorage('notice') &&
      getSessionStorage('isCoupons')
    ) {
      let domStyle =
        '.gm-fullscreen-control{top: 126rem !important;}.choose-list{top: 104rem !important;}';
      this.handleMapFullScreenStyle(domStyle);
    } else {
      let domStyle =
        '.gm-fullscreen-control{top: 86rem !important;}.choose-list{top: 76rem !important;}';
      this.handleMapFullScreenStyle(domStyle);
    }
  };

  // 地图全屏控件样式
  handleMapFullScreenStyle = (controlStyle) => {
    let domStyle = controlStyle;
    let dom = document.getElementsByClassName('charter-quote')[0];
    let style = document.createElement('style');
    style.type = 'text/css';
    if (style.styleSheet) {
      style.styleSheet.cssText = domStyle;
    } else {
      style.appendChild(document.createTextNode(domStyle));
    }
    dom.appendChild(style);
  };

  //更新出发地&目的地聚焦
  updateInputFocus = (type) => {
    this.setState({
      currentFocusInput: type,
    });
  };

  //更新出发地&目的地校验
  updateInputRules = (type) => {
    let { inputRules } = this.state;
    //更新出发地、目的地校验
    if (type === 'from') {
      inputRules.fromCity = false;
    } else {
      inputRules.toCity = false;
    }
    this.setState({
      inputRules,
    });
  };

  // 过滤出当月有航班的日期
  dateRender = (current, type) => {
    let { dateMonth, dateMonthOnce } = this.state;
    let style = {};
    if (type === 'two') {
      if (
        moment(current).format(`YYYY-MM-DD`) <
          moment(dateMonthOnce).startOf('month').format(`YYYY-MM-DD`) ||
        moment(current).format(`YYYY-MM-DD`) >
          moment(dateMonthOnce).endOf('month').format(`YYYY-MM-DD`)
      ) {
        style.display = 'none';
      }
    } else {
      if (
        moment(current).format(`YYYY-MM-DD`) <
          moment(dateMonth).startOf('month').format(`YYYY-MM-DD`) ||
        moment(current).format(`YYYY-MM-DD`) > moment(dateMonth).endOf('month').format(`YYYY-MM-DD`)
      ) {
        style.display = 'none';
      }
    }
    return (
      <div className="ant-picker-cell-inner" style={style}>
        {current.date()}
      </div>
    );
  };
  // 日历点击下一个月的回调
  onPanel = (current) => {
    let date = moment(current).format('YYYY-MM');
    this.setState({
      dateMonth: date,
    });
  };
  onPanelOnce = (current) => {
    let date = moment(current).format('YYYY-MM-DD');
    this.setState({
      dateMonthOnce: date,
    });
  };

  //
  handleOpenChange = (open) => {
    let { currentDate, currentDateOnce } = this.state;
    if (open) {
      const { lastSelectedDate, lastSelectedDateOnce } = this.state;
      if (lastSelectedDate) {
        this.setState({
          currentDate: moment(lastSelectedDate),
        });
      }
      if (lastSelectedDateOnce) {
        this.setState({
          currentDateOnce: moment(lastSelectedDateOnce),
        });
      }
      if (currentDate) {
        this.setState({
          dateMonth: currentDate,
        });
      }
      if (currentDateOnce) {
        this.setState({
          dateMonthOnce: currentDateOnce,
        });
      }
    }
  };

  // 获取专属链接参数
  getCharterUrlParams = async (urlParams) => {
    const departureTime = moment().add(10, 'days').startOf('day');
    const startId = urlParams.get('startId');
    const endId = urlParams.get('endId');
    const startIdType = urlParams.get('startIdType');
    const endIdType = urlParams.get('endIdType');

    const stateObj = {
      currentDate: moment(departureTime, 'YYYY-MM-DD'),
      time: departureTime.format('h:mm A'),
      timeName: departureTime.format('HH:mm'),
      fromValue: {
        id: startId,
        name: urlParams.get('startKey'),
        idType: startIdType,
      },
      toValue: {
        id: endId,
        name: urlParams.get('endKey'),
        idType: endIdType,
      },
    };
    if (urlParams.get('tripType') === '1') {
      const returnTime = moment().add(11, 'days').startOf('day');
      stateObj.currentDateOnce = moment(returnTime, 'YYYY-MM-DD');
      stateObj.timeOnce = returnTime.format('h:mm A');
      stateObj.timeOnceName = returnTime.format('HH:mm');
      stateObj.tripIndex = 1;
    }
    this.setState(stateObj);
  };

  async componentDidMount() {
    const { location } = this.props;
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.size) {
      await this.getCharterUrlParams(urlParams);
    } else {
      // 获取缓存数据
      await this.getCacheData();
    }

    // 搜索结果列表
    await this.getResultsList();

    this.mapControlStyle();
  }

  componentWillUnmount() {
    clearSessionStorage('chaData');
    this.unsubscribe();
  }

  render() {
    let {
      resultsList,
      tripList,
      tripIndex,
      fromValue,
      toValue,
      currentDate,
      currentDateOnce,
      openDataList,
      time,
      timeName,
      timeOnceName,
      timeOnce,
      passengerNumber,
      passengerActive,
      currentFocusInput,
      inputRules,
      dialogType,
      dialogContent,
      addUserInfoShow,
      dateShow,
      dateTwoShow,
      searchSuccess,
      emptyLegList,
      scheduleList,
      scheduleShow,
      emptyLegShow,
      roundtrip,
    } = this.state;
    const { location } = this.props;
    const urlParams = new URLSearchParams(location.search);
    const defaultStartKey = urlParams.get('startKey') || '';
    const defaultEndKey = urlParams.get('endKey') || '';
    return (
      <>
        <HeaderMeta type="charterQuote" />
        <div className="charter-quote">
          <header className="charter-quote-header" ref={this.headerRef}>
            {/* 飞机搜索 */}
            <nav className="results-top">
              <div>
                <div className="banner-title">
                  <h1>Private Charter Quotes</h1>
                  <p>Search flights and get a private charter quote based on your itinerary</p>
                </div>
                <form className="results-form-content" id="charter-quote-search">
                  <div className="results-form-wrapper">
                    <div className="results-options options-left">
                      <div className="depart-type">
                        {tripList.map((item, index) => {
                          return (
                            <button
                              type="button"
                              key={index}
                              className={`${tripIndex === index ? 'active' : ''}`}
                              onClick={() => {
                                this.switchType(index);
                              }}
                            >
                              {item}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                    <div className="results-options options-right">
                      <div
                        className={`results-address ${
                          tripIndex === 0 ? 'results-address-one' : 'results-address-two'
                        }`}
                      >
                        <div className="address-items">
                          <SearchAirportCharter
                            type="from"
                            page="charterQuote"
                            dataValue={fromValue}
                            resultSstyle="results-style"
                            getAddress={this.getAddress}
                            clearFlightsList={this.clearFlightsList}
                            onRef={(c) => (this.ChildPage1 = c)}
                            currentFocusInput={currentFocusInput}
                            inputRules={inputRules}
                            updateInputFocus={this.updateInputFocus}
                            updateInputRules={this.updateInputRules}
                            getfocus={this.getFocus}
                            defaultSearchKey={defaultStartKey} // city or airport name
                          />
                        </div>
                        {/* <div className="address-items swap-item">
                        <button
                          className="swaper"
                          onClick={() => {
                            this.reverse();
                          }}
                        >
                          <i className="bg-image"></i>
                        </button>
                      </div> */}
                        <div className="address-items">
                          <SearchAirportCharter
                            type="to"
                            page="charterQuote"
                            dataValue={toValue}
                            resultSstyle="results-style"
                            getAddress={this.getAddress}
                            clearFlightsList={this.clearFlightsList}
                            onRef={(c) => (this.ChildPage2 = c)}
                            currentFocusInput={currentFocusInput}
                            inputRules={inputRules}
                            updateInputFocus={this.updateInputFocus}
                            updateInputRules={this.updateInputRules}
                            getfocus={this.getFocus}
                            defaultSearchKey={defaultEndKey} // city or airport name
                          />
                        </div>
                        <div className="address-items">
                          <div className="results-deta">
                            <div className="icon-text">
                              {/* <img
                              src={require('../../assets/imgs/svg/date.svg').default}
                              alt="date icon"
                            /> */}
                              <span className={`${inputRules.fromDate ? 'error' : ''}`}>
                                Departure Date
                              </span>
                            </div>
                            <div className="date-time-item">
                              <DatePicker
                                className="charter-date"
                                id="picker"
                                ref={this.pickerRef}
                                format={'MMM DD, YYYY'}
                                disabledDate={this.disabledDateStart}
                                placeholder={'Date'}
                                allowClear={false}
                                bordered={false}
                                suffixIcon={''}
                                value={currentDate}
                                onChange={(e) => this.changeDate(e, 'one')}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                onFocus={() => {
                                  this.setState({ dateShow: true });
                                }}
                                onBlur={() => {
                                  this.setState({ dateShow: false });
                                }}
                                open={dateShow}
                                dateRender={(current) => this.dateRender(current, 'one')}
                                onPanelChange={(current) => this.onPanel(current)}
                                onOpenChange={this.handleOpenChange}
                                defaultPickerValue={this.state.lastSelectedDate}
                              />
                              <Select
                                placeholder={'Time'}
                                onDropdownVisibleChange={(openType) =>
                                  this.openSelectTime(openType, 'one')
                                }
                                onChange={(e) => this.handleChange(e, 'one')}
                                value={time}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                open={this.state.openSelect}
                              >
                                {openDataList.map((item, index) => {
                                  return (
                                    <Option value={item.value} key={index}>
                                      {item.label}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </div>
                          </div>
                        </div>
                        <div className="address-items">
                          <div className="passenger-amount">
                            <span className={`text ${passengerActive ? 'active' : ''}`}>
                              Passengers
                            </span>
                            <div className="passenger-input-wrapper">
                              <Input
                                type="number"
                                min={1}
                                max={99}
                                placeholder="Amount of passengers"
                                onInput={(e) => {
                                  this.passengerInput(e);
                                }}
                                onBlur={(e) => this.passengerBlur(e)}
                                value={passengerNumber}
                                onFocus={(e) => {
                                  this.passengerFocus(e);
                                }}
                              />
                              <div className="passenger-arrows">
                                <button
                                  className="arrow-btn up-arrow"
                                  onClick={() => this.incrementPassenger()}
                                  type="button"
                                >
                                  ▲
                                </button>
                                <button
                                  className="arrow-btn down-arrow"
                                  onClick={() => this.decrementPassenger()}
                                  type="button"
                                >
                                  ▼
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        {tripIndex === 1 ? (
                          <Fragment>
                            <div className="address-items two-deta">
                              <div className="results-deta">
                                <div className="icon-text">
                                  <span className={`${inputRules.toDate ? 'error' : ''}`}>
                                    Return Date
                                  </span>
                                </div>
                                <div className="date-time-item">
                                  <DatePicker
                                    id="picker-two"
                                    ref={this.picker2Ref}
                                    className="charter-date"
                                    format={'MMM DD, YYYY'}
                                    disabledDate={this.disabledDateEnd}
                                    placeholder={'Date'}
                                    allowClear={false}
                                    bordered={false}
                                    suffixIcon={''}
                                    value={currentDateOnce}
                                    onChange={(e) => this.changeDate(e, 'two')}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    onFocus={() => {
                                      this.setState({ dateTwoShow: true });
                                    }}
                                    onBlur={() => {
                                      this.setState({ dateTwoShow: false });
                                    }}
                                    open={dateTwoShow}
                                    dateRender={(current) => this.dateRender(current, 'two')}
                                    onPanelChange={(current) => this.onPanelOnce(current)}
                                    onOpenChange={this.handleOpenChange}
                                    defaultPickerValue={this.state.lastSelectedDateOnce}
                                  />
                                  <Select
                                    placeholder={'Time'}
                                    onDropdownVisibleChange={(openType) =>
                                      this.openSelectTime(openType, 'two')
                                    }
                                    onChange={(e) => this.handleChange(e, 'two')}
                                    value={timeOnce}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    open={this.state.openSelectTwo}
                                  >
                                    {openDataList.map((item, index) => {
                                      return (
                                        <Option value={item.value} key={index}>
                                          {item.label}
                                        </Option>
                                      );
                                    })}
                                  </Select>
                                </div>
                              </div>
                            </div>
                          </Fragment>
                        ) : null}
                      </div>
                    </div>
                    <button
                      className="address-items charter-search"
                      type="button"
                      onClick={() => this.searchCharquote()}
                    >
                      Search
                    </button>
                  </div>
                </form>
              </div>

              <p className={`${searchSuccess ? 'isNot' : 'isShow'} search-success-text`}>
                Use the charter flight cost calculator to receive a free charter flight estimate.
                Your charter flight specialist will send you a quote that includes the full picture
                of chartering a private jet, including additional costs such as airport fees or fuel
                surcharges.
              </p>
            </nav>
            {/* banner */}
            <img
              src={require('../../assets/imgs/webp/charter-banner.webp').default}
              alt="Charter Banner"
              className="charter-quote-banner"
            />
          </header>

          {/* Featured Flights 模块 */}
          {scheduleShow || emptyLegShow ? (
            <FeaturedFlights
              roundtrip={roundtrip}
              scheduleList={scheduleList}
              emptyLegList={emptyLegList}
              currentDate={currentDate}
              timeName={timeName}
              currentDateOnce={currentDateOnce}
              timeOnceName={timeOnceName}
              passengerNumber={passengerNumber}
              fromValue={fromValue}
              toValue={toValue}
            />
          ) : null}

          {/* 数据内容 */}
          <div className={`quote-container ${resultsList.length ? 'quote-container-icon' : ''}`}>
            <div className="max-width">
              {resultsList.length > 0 ? (
                <div className="charter-title" ref={this.titleRef}>
                  <h1>Charter Flight Cost Calculator</h1>
                  <p>
                    You can proceed to booking after viewing your estimate, or contact a charter
                    sales rep to discuss further.
                  </p>
                </div>
              ) : null}
              {/* 航班列表 */}
              {resultsList && resultsList.length > 0 ? (
                <div className="results-content" ref={this.resultRef}>
                  {resultsList.map((item, index) => {
                    return (
                      <div className="results-list" key={index}>
                        <div className="aircraft-type">{item.Category}</div>
                        <div className="aircraft-item">
                          <div className="item-images">
                            {item.Picture &&
                              item.Picture.map((img, index) => {
                                return index < 2 ? (
                                  <img
                                    key={index}
                                    src={`${process.env.REACT_APP_RESOURCE_URL}/${img}`}
                                    alt={`private jet charter ${item.Model}`}
                                  />
                                ) : null;
                              })}
                          </div>
                          <div className="item-information">
                            <ul className="information-left">
                              <li>
                                <img
                                  src={require('../../assets/imgs/svg/new-air-icon.svg').default}
                                  alt="aircraft icon"
                                />
                                <div className="configuration-text">
                                  <span>Aircraft</span>
                                  <span className="air-model">{item.Model}, etc</span>
                                </div>
                              </li>
                              <li>
                                <img
                                  src={require('../../assets/imgs/svg/new-seat-icon.svg').default}
                                  alt="sear icon"
                                />
                                <div className="configuration-text">
                                  <span>Seats</span>
                                  <span>{item.Seat}</span>
                                </div>
                              </li>
                              <li>
                                <img
                                  src={require('../../assets/imgs/svg/new-time-icon.svg').default}
                                  alt="time icon"
                                />
                                <div className="configuration-text">
                                  <span>Average Duration</span>
                                  <span>
                                    {item.FlightTime > 0 ? switchTime(item.FlightTime) : 0}
                                  </span>
                                </div>
                              </li>
                            </ul>
                            <ul className="information-right">
                              <li>
                                <div className="configuration-text">
                                  <span className="estimated-price">Estimated Pirce</span>
                                  {tripIndex === 0 ? (
                                    <span className="price">
                                      <span>USD</span> ${divisionNumber(item.minPrice)}&nbsp; -
                                      &nbsp;$
                                      {divisionNumber(item.maxPrice)}
                                    </span>
                                  ) : (
                                    <span className="price">
                                      <span>USD</span> ${divisionNumber(item.minPrice * 2)}&nbsp; -
                                      &nbsp;$
                                      {divisionNumber(item.maxPrice * 2)}
                                    </span>
                                  )}
                                </div>
                              </li>
                              <li>
                                <span>
                                  Prices are estimates only. Lead time, availability, and demand
                                  will affect formal quotes.
                                </span>
                              </li>
                              <li>
                                <button
                                  className="quote-btn"
                                  onClick={() => {
                                    this.submitInquireHandle(item);
                                  }}
                                >
                                  Inquire
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : null}

              {/* 预约流程说明 */}
              <Description />
            </div>
          </div>

          <Footer />
          {/* 填写手机号码弹窗&提交成功弹窗 */}
          {dialogType ? (
            <InquireDialog
              history={this.props.history}
              dialogType={dialogType}
              type="charterQuote"
              dialogContent={dialogContent}
              closeDialogHandle={this.closeDialogHandle}
              inquireId={this.state.inquireId}
              routerId={this.state.routerId}
              sourceMenuShow={this.state.sourceMenuShow}
              showDialogHandle={this.showDialogHandle}
              submitInquireAjax={this.submitInquireAjax}
              currentParams={this.state.currentParams}
            />
          ) : null}
          {/* 未登录时补全用户信息 */}
          {addUserInfoShow && (
            <AddUserInfo
              history={this.props.history}
              currentParams={this.state.currentParams}
              closeDialogHandle={this.closeDialogHandle}
              submitInquireAjax={this.submitInquireAjax}
            />
          )}
        </div>
      </>
    );
  }
}
